import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const resizeObserverMessage='ResizeObserver loop completed with undelivered notifications.';

if(process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (event) => {
    if(event.message === resizeObserverMessage) {
      event.stopImmediatePropagation();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason=event.reason;
    const message=typeof reason === 'string' ? reason : reason && reason.message;

    if(message === resizeObserverMessage) {
      event.preventDefault();
    }
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
